"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECommerce = void 0;
var Cart_1 = require("./Cart");
var Custom_1 = require("./platformsManagers/Custom");
var Nuvemshop_1 = require("./platformsManagers/Nuvemshop");
var Vtex_1 = require("./platformsManagers/Vtex");
var ECommerce = /** @class */ (function () {
    function ECommerce(userID, window, services, logger, apis) {
        this.userID = userID;
        this.window = window;
        this.storage = services.localStorage;
        this.logger = logger;
        this.browser = services.browserEnvironment;
        this.platformInterval = null;
        this.timerFrequency = 1000;
        this.retries = 5;
        var storedCart = this.storedCart ? this.storedCart : Cart_1.Cart.empty();
        this.cart = new Cart_1.Cart(storedCart, this.storage);
        this.checkAndDispatchCartEvent = this.checkAndDispatchCartEvent.bind(this);
        this.checkAndDispatchOrderEvent = this.checkAndDispatchOrderEvent.bind(this);
        this.platformInterval = setInterval(this.setPlatform.bind(this), this.timerFrequency);
        this.apis = apis;
        this.registerDefaultEvents();
    }
    ECommerce.detectPlatform = function (window) {
        if (window.hasOwnProperty('LS'))
            return 'nuvemshop';
        else if (window.hasOwnProperty('vtex'))
            return 'vtex';
        else
            return 'custom';
    };
    ECommerce.prototype.checkAndDispatchEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.debug('Initializing ecommerce events tracking');
                        return [4 /*yield*/, this.checkAndDispatchCartEvent()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.checkAndDispatchOrderEvent()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ECommerce.prototype.checkAndDispatchCartEvent = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.platform === undefined)
                            return [2 /*return*/];
                        this.logger.debug('Checking cart tracking');
                        cart = e !== undefined ? this.platform.extractCartFromEvent(e) : this.platform.getCart();
                        if (!this.cart.hasNewItem(cart)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.saveAddToCartEvent()];
                    case 1:
                        _a.sent();
                        this.logger.debug('Cart was changed. Firing add to cart event');
                        _a.label = 2;
                    case 2:
                        this.cart.update(cart);
                        return [2 /*return*/];
                }
            });
        });
    };
    ECommerce.prototype.checkAndDispatchOrderEvent = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var order;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.platform === undefined)
                            return [2 /*return*/];
                        this.logger.debug('Checking order tracking');
                        order = e !== undefined ? this.platform.extractOrderFromEvent(e) : this.platform.getOrder();
                        if (!(order && order.isCompleted)) return [3 /*break*/, 2];
                        this.logger.debug('Order was created. Firing order created event');
                        return [4 /*yield*/, this.saveOrderCreatedEvent(order)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ECommerce.prototype, "storedCart", {
        get: function () {
            return this.storage.get('cart') || null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the platformManager found from either storeType or heuristics to this.platform.
     * Will attempt to detect up to 5 times (this.retries initial value) before falling back to Custom
     */
    ECommerce.prototype.setPlatform = function () {
        if (this.cart === undefined)
            throw new Error("Should not set cart before it's initialization");
        var platformName = ECommerce.detectPlatform(this.window);
        switch (platformName) {
            case 'nuvemshop':
                this.logger.debug('Nuvemshop ecommerce was found');
                this.platform = new Nuvemshop_1.Nuvemshop(this.window);
                break;
            case 'vtex':
                this.logger.debug('Vtex ecommerce was found');
                this.platform = new Vtex_1.Vtex(this.window, this.storage);
                break;
            default:
                this.retries--;
                this.logger.debug("[ECommerce]Trying to identify eshop. retries left: ".concat(this.retries));
                break;
        }
        if (this.retries <= 0) {
            this.logger.debug('No platform found. Defaulting to custom');
            this.platform = new Custom_1.Custom(this.window);
        }
        if (this.platform) {
            this.clearPlatformInterval();
            this.platform.registerEvents(this.checkAndDispatchCartEvent, this.checkAndDispatchOrderEvent);
            this.checkAndDispatchEvents();
        }
    };
    ECommerce.prototype.events = function (action, type, payload) {
        this.logger.trace("Calling ecom ".concat(action, " ").concat(type, " ").concat(JSON.stringify(payload)));
        try {
            switch (type) {
                case 'order':
                    var order = this.getOrderDetails(payload);
                    return this.saveOrderCreatedEvent(order);
                case 'addToCart':
                    return this.saveAddToCartEvent();
            }
        }
        catch (e) {
            this.logger.error("".concat(e.message));
        }
    };
    /**
     * This method clear the stored interval when
     * specifics platforms are detected or there are not more retries
     * // TODO: Move it to an abstraction class ( Platform )
     */
    ECommerce.prototype.clearPlatformInterval = function () {
        this.logger.debug("[ECommerce] clearing timer");
        clearInterval(this.platformInterval);
        this.platformInterval = null;
    };
    ECommerce.prototype.registerDefaultEvents = function () {
        this.window.addEventListener('socitalAddToCart', this.handleAddToCart.bind(this));
        this.window.addEventListener('socitalOrderCreated', this.handleOrderCreated.bind(this));
    };
    ECommerce.prototype.handleAddToCart = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: check if event is custom and log the body
                this.logger.trace("Got add to cart event from the ecommerce platform");
                return [2 /*return*/, this.saveAddToCartEvent()];
            });
        });
    };
    ECommerce.prototype.handleOrderCreated = function (e) {
        var event = e;
        this.logger.trace("Got order created event from the ecommerce platform. ".concat(JSON.stringify(event.detail)));
        var order = this.getOrderDetails(event.detail);
        return this.saveOrderCreatedEvent(order);
    };
    ECommerce.prototype.getOrderDetails = function (payload) {
        var details = payload || {};
        var orderDetails = {
            id: details.orderID,
            subtotal: details.totalPrice ? parseFloat(details.totalPrice) : undefined,
            currency: details.currency,
            createdAt: new Date(),
            isCompleted: true
        };
        if (details.customerID)
            orderDetails.customerID = details.customerID.toString();
        if (details.coupon)
            orderDetails.coupon = details.coupon;
        if (details.phone)
            orderDetails.phone = details.phone;
        return orderDetails;
    };
    ECommerce.prototype.saveAddToCartEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendEvent("/api/v1/cart/item", 'addToCart', {})];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // TODO: create a wrapper that communicates with the backend along with the correct types
    // We have transformed the order object way to much times that end up hard to follow
    // let's try to simplify this logic a bit and make sure we have a complete test suite
    // to prevent those from breaking
    ECommerce.prototype.saveOrderCreatedEvent = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var orderPayload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderPayload = {
                            price: order.subtotal,
                            currency: order.currency,
                            createdAt: order.createdAt
                        };
                        if (order.customerID)
                            orderPayload.customerID = String(order.customerID);
                        if (order.id)
                            orderPayload.orderID = String(order.id);
                        if (order.coupon)
                            orderPayload.coupon = order.coupon;
                        if (order.phone)
                            orderPayload.phoneNumber = order.phone;
                        return [4 /*yield*/, this.sendEvent("/api/v1/orders", 'orderCreated', {
                                order: orderPayload
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ECommerce.prototype.sendEvent = function (url, eventType, eventPayload) {
        var headers = { 'X-SOCITAL-DOMAIN': this.browser.currentUrl };
        this.logger.trace("Sending ".concat(eventType, " event to backend."), { method: 'POST', headers: headers });
        var cttToken = this.storage.get('cttToken');
        var ecid = this.storage.get('ecid') || undefined;
        var body = __assign({ cttToken: cttToken === null || cttToken === void 0 ? void 0 : cttToken.value, ecid: ecid, environment: this.browser.snapshot, userID: this.userID }, eventPayload);
        try {
            return this.apis.publicApi.postJson(url, body, headers);
        }
        catch (err) {
            this.logger.error({ 'user.id': this.userID }, "Error while saving ".concat(eventType, " event - ").concat(err));
        }
    };
    return ECommerce;
}());
exports.ECommerce = ECommerce;
//# sourceMappingURL=data:application/json;base64,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